import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ViewModelService } from '../shared/view-model.service';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';

const POLL_INTERVAL_MS = 10000;
const MAX_POLLS = 12; // 2 minutes

@Component({
   selector: 'app-stepthree-confirm',
   standalone: true,
   imports: [SpinnerComponent],
   templateUrl: './stepthree-confirm.component.html',
   styleUrl: './stepthree-confirm.component.scss',
})
export class StepthreeConfirmComponent implements OnInit, OnDestroy {
   timedOut = false;

   public vm = inject(ViewModelService);
   private http = inject(HttpClient);

   private pollCount = 0;
   private pollTimer: ReturnType<typeof setTimeout> | null = null;

   ngOnInit(): void {
      this.schedulePoll();
   }

   ngOnDestroy(): void {
      this.clearTimer();
   }

   private schedulePoll(): void {
      this.pollTimer = setTimeout(() => this.poll(), POLL_INTERVAL_MS);
   }

   private poll(): void {
      this.pollCount++;

      this.http.get<{ ready: boolean }>('/api/refreshclaims').subscribe({
         next: (result) => {
            if (result.ready) {
               console.log('[StepthreeConfirm] claims ready after', this.pollCount, 'poll(s) — navigating');
               this.continue();
            } else {
               console.log('[StepthreeConfirm] claims not yet ready (poll', this.pollCount, '/', MAX_POLLS, ')');
               this.continuePollingOrGiveUp();
            }
         },
         error: (err) => {
            console.warn('[StepthreeConfirm] refreshclaims request failed on attempt', this.pollCount, err);
            this.continuePollingOrGiveUp();
         },
      });
   }

   private continuePollingOrGiveUp(): void {
      if (this.pollCount >= MAX_POLLS) {
         console.warn('[StepthreeConfirm] Polling timed out after', MAX_POLLS, 'attempts');
         this.timedOut = true;
      } else {
         this.schedulePoll();
      }
   }

   private clearTimer(): void {
      if (this.pollTimer !== null) {
         clearTimeout(this.pollTimer);
         this.pollTimer = null;
      }
   }

   continue(): void {
      this.clearTimer();
      window.open(this.vm.resumeUrl, '_self');
   }

   login(): void {
      this.clearTimer();
      window.open(this.vm.loginUrl, '_self');
   }
}
